/**
 * Shared constants + helpers for MaterialMovement.jsx and TransferSheet.jsx.
 * Kept as a small module so both files stay independently readable.
 */
import React from "react";
import { Label } from "@/components/ui/label";
import { Warehouse, MapPin } from "@phosphor-icons/react";

export const STATUS_PILL = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  in_transit: "bg-amber-50 text-amber-800 border-amber-200",
  received: "bg-emerald-50 text-emerald-800 border-emerald-200",
  partial_receipt: "bg-blue-50 text-blue-800 border-blue-200",
  verified: "bg-purple-50 text-purple-800 border-purple-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
};

export const DIR_META = {
  warehouse_to_warehouse: { label: "W → W", cls: "bg-slate-100 text-slate-700" },
  warehouse_to_site:      { label: "W → S", cls: "bg-orange-50 text-orange-700" },
  site_to_site:           { label: "S → S", cls: "bg-indigo-50 text-indigo-700" },
  site_to_warehouse:      { label: "S → W (Return)", cls: "bg-emerald-50 text-emerald-700" },
};

export function Field({ label, children, span = 1 }) {
  return (
    <div style={{ gridColumn: `span ${span}` }}>
      <Label className="text-[10px] font-semibold uppercase tracking-widest text-slate-500 mb-1 block">{label}</Label>
      {children}
    </div>
  );
}

export function dirKey(t) {
  return `${t?.source?.kind}_to_${t?.destination?.kind}`;
}

export function iconForKind(kind) {
  return kind === "warehouse"
    ? <Warehouse size={12} className="text-slate-500 inline mr-1" />
    : <MapPin size={12} className="text-orange-600 inline mr-1" />;
}
